import $ from 'cash-dom';

// Find the right method, call on correct element
function launchIntoFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}
function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}
function onFullScreenChange() {
  const fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
  if (fullscreenElement) {
    $('#bigpicture').addClass('is-fullscreen');
  } else {
    $('#bigpicture').removeClass('is-fullscreen');
  }
}
export default function () {
  if ($('.js-tabs--trigger').length > 0) {
    $('.js-tabs--trigger').on('click touch', function (e) {
      const tab = $(this).attr('href').substr(1);
      const tabElement = $(this).closest('.bigpicture__section').find(`[data-id='${tab}']`);
      $(this).addClass('is-active').siblings().removeClass('is-active');
      $(tabElement).removeClass('hidden').siblings().addClass('hidden');
      e.preventDefault();
      return false;
    });
    document.addEventListener('fullscreenchange', onFullScreenChange, false);
    document.addEventListener('webkitfullscreenchange', onFullScreenChange, false);
    document.addEventListener('mozfullscreenchange', onFullScreenChange, false);
    $('.js-fullscreen').on('click touch', () => {
      launchIntoFullscreen(document.getElementById('bigpicture'));
      return false;
    });
    $('.js-exitfullscreen').on('click touch', () => {
      exitFullscreen();
      return false;
    });
  }
}